<template>
  <span class="file-icon togo-icon-stack togo-icon-2x togo-icon-filetype-stack">
    <i class="togo-icon togo-icon-box togo-icon-stack-2x" :class="underlayClass"></i>
    <i v-if="!icon" class="togo-icon togo-icon-file togo-icon-stack-2x overlay-file"></i>
    <i class="togo-icon togo-icon-stack-2x" :class="[iconClass, overlayClass]"></i>
  </span>
</template>

<script>
const icons = {
  doc: 'file-doc',
  docx: 'file-doc',
  xls: 'file-xls',
  xlsx: 'file-xls',
  ppt: 'file-ppt',
  pptx: 'file-ppt',
  mov: 'video',
  wmv: 'video',
  mp4: 'video',
  mp3: 'music',
  pdf: 'file-pdf',
  png: 'image',
  jpg: 'image',
  jpeg: 'image',
  gif: 'image',
  tiff: 'image',
  svg: 'image',
  bmp: 'image'
};

const FileIcon = {
  name: 'FileIcon',

  props: ['fileType'],

  computed: {
    icon() {
      return icons[(this.fileType || '').toLowerCase()];
    },

    iconClass() {
      if (this.icon) {
        return `togo-icon-${this.icon}`;
      }
      return 'togo-icon-file-curl';
    },

    underlayClass() {
      if (this.icon) {
        return `underlay-${this.icon}`;
      }
      return 'underlay-file';
    },

    overlayClass() {
      if (this.icon) {
        return 'overlay';
      }
      return 'overlay-file-curl';
    }
  }
};

export default FileIcon;
</script>
